import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import surahList from './home/surahList';
import BottomBar from '../components/BottomBar';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import back from '../assets/icon/back.svg';

import './ReviewTest.css';
import './home/DailyView.css';



const ReviewTest = () => {
  const [selectedSurah, setSelectedSurah] = useState(null);
  const [ayahs, setAyahs] = useState([]);
  const [shuffled, setShuffled] = useState([]);
  const [sequence, setSequence] = useState([]);
  const [result, setResult] = useState(null);
  const [testType, setTestType] = useState('ترتيب الايات');
  const [showPopup, setShowPopup] = useState(false);
  const [mode, setMode] = useState('full');
  const [startAyah, setStartAyah] = useState('');
  const [endAyah, setEndAyah] = useState('');
  const [testStarted, setTestStarted] = useState(false);
  const [feedback, setFeedback] = useState(null); // {message, type}
  const [reviewRanges, setReviewRanges] = useState([]);
  const [selectedRange, setSelectedRange] = useState(null);

  const testTypes = [
    { name: 'ترتيب الايات', description: 'اختبر قدرتك على ترتيب الآيات في السورة.' },
    { name: 'الربط', description: 'اختبر قدرتك على ربط الصفحات مع بعضها.' },
    { name: 'اكمل من قولة تعالى', description: 'اختبر حفظك في السورة عن طريق اكمال الايات' },
    { name: 'كتابة الايات', description: 'اختبر قدرتك على كتابة الآيات من الذاكرة (قريبا).' },
    { name: 'تلاوة الايات', description: ' اختبر تلاوتك للآيات المختارة (قريبا)' },
  ];
  
//   cosnt [testType, setTestType] = useState();
  const navigate = useNavigate();
  const handleTestTypeClick = (type) => {
    setTestType(type);
    if (
      type === 'ترتيب الايات' ||
      type === 'اكمل من قولة تعالى' ||
      type === 'الربط'
      // type === 'كتابة الايات'
    ) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
      setTestStarted(false);
    }
  };
  useEffect(() => {
    if (feedback) {
      const t = setTimeout(() => setFeedback(null), 7000);
      return () => clearTimeout(t);
    }
  }, [feedback]);
  useEffect(() => {
    if (!showPopup) return;
    const fetchRanges = async () => {
      const token = localStorage.getItem('access');
      if (!token) return;
      try {
        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWT ${token}`,
          },
        };
        const res = await axios.get(`${process.env.REACT_APP_API_URL}get-reviewed-ayahs/`, config);
        if (res.data && res.data.surahs) {
          const opts = [];
          res.data.surahs.forEach((s) => {
            s.ranges.forEach((r) => {
              opts.push({
                value: { surah: s.surah_number, start: r.start_ayah, end: r.end_ayah },
                label: `سورة ${s.name_ar} من ${r.start_ayah} إلى ${r.end_ayah}`,
              });
            });
          });
          setReviewRanges(opts);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchRanges();
  }, [showPopup]);



  useEffect(() => {
    if (!selectedSurah) return;
    fetch(`https://api.alquran.cloud/v1/surah/${selectedSurah.value}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
          const list = data.data.ayahs.map((a) => ({
            number: a.numberInSurah,
            text: a.text,
          }));
          setAyahs(list);
          setShuffled(shuffle(list));
          setSequence([]);
          setResult(null);
        }
      })
      .catch((err) => console.error(err));
  }, [selectedSurah]);

  const shuffle = (arr) => {
    const array = [...arr];
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const selectAyah = (item) => {
    setSequence([...sequence, item]);
    setShuffled(shuffled.filter((a) => a.number !== item.number));
  };

  const checkOrder = () => {
    const correct = ayahs.every((a, idx) => sequence[idx]?.number === a.number);
    setResult(correct ? 'correct' : 'wrong');
  };
  const startOrderingTest = () => {
    if (!selectedSurah) {
        setFeedback({ type: 'error', message: 'يرجى اختيار سورة' });
        return;
      }
    if (mode === 'range') {
      const start = parseInt(startAyah, 10);
      const end = parseInt(endAyah, 10);
      if (
        isNaN(start) ||
        isNaN(end) ||
        start < 1 ||
        end > ayahs.length ||
        start > end
      ) {
        alert('يرجى تحديد البداية والنهاية بشكل صحيح');
        return;
      }
      navigate(
        `/ordering-test?surah=${selectedSurah.value}&mode=range&start=${start}&end=${end}`
      );
    } else {
      navigate(`/ordering-test?surah=${selectedSurah.value}&mode=full`);
    }

  };
  const startCompleteTest = () => {
    if (!selectedSurah) {
      setFeedback({ type: 'error', message: 'يرجى اختيار سورة' });
      return;
    }
    if (mode === 'range') {
        const start = parseInt(startAyah, 10);
        const end = parseInt(endAyah, 10);
        if (
          isNaN(start) ||
          isNaN(end) ||
          start < 1 ||
          end > ayahs.length ||
          start > end
        ) {
          alert('يرجى تحديد البداية والنهاية بشكل صحيح');
          return;
        }
        navigate(
          `/complete-test?surah=${selectedSurah.value}&mode=range&start=${start}&end=${end}`
        );
      } else {
        navigate(`/complete-test?surah=${selectedSurah.value}&mode=full`);
      }  };
  const startLinkingTest = () => {
    if (!selectedSurah) {
      setFeedback({ type: 'error', message: 'يرجى اختيار سورة' });
      return;
    }
    if (mode === 'range') {
        const start = parseInt(startAyah, 10);
        const end = parseInt(endAyah, 10);
        if (
          isNaN(start) ||
          isNaN(end) ||
          start < 1 ||
          end > ayahs.length ||
          start > end
        ) {
          alert('يرجى تحديد البداية والنهاية بشكل صحيح');
          return;
        }
        navigate(
          `/linking-test?surah=${selectedSurah.value}&mode=range&start=${start}&end=${end}`
        );
      } else {
        navigate(`/linking-test?surah=${selectedSurah.value}&mode=full`);
      }
  };
  // const startWritingTest = () => {
  //   if (!selectedSurah) {
  //     setFeedback({ type: 'error', message: 'يرجى اختيار سورة' });
  //     return;
  //   }
  //   if (mode === 'range') {
  //     const start = parseInt(startAyah, 10);
  //     const end = parseInt(endAyah, 10);
  //     if (
  //       isNaN(start) ||
  //       isNaN(end) ||
  //       start < 1 ||
  //       end > ayahs.length ||
  //       start > end
  //     ) {
  //       alert('يرجى تحديد البداية والنهاية بشكل صحيح');
  //       return;
  //     }
  //     navigate(
  //       `/writing-test?surah=${selectedSurah.value}&mode=range&start=${start}&end=${end}`
  //     );
  //   } else {
  //     navigate(`/writing-test?surah=${selectedSurah.value}&mode=full`);
  //   }
  // };


  return (
    <div className="review-test">
      <h1>اختبر حفظك</h1>
     {feedback && (
        <div
          className={`feedback-popup ${feedback.type === 'success' ? 'success' : 'error'}`}
        >
          {feedback.message}
        </div>
      )}
      {/* <div className="back-icon-container">
        <img
          className="back-icon"
          src={back}
          alt="back"
          onClick={() => navigate(-1)}
        />
      </div> */}
      {/* <Select
        options={surahList}
        value={selectedSurah}
        onChange={setSelectedSurah}
        placeholder="اختر السورة"
        isSearchable
        className="surah-select"
      /> */}
      {/* {selectedSurah && ( */}
      <div className="test-cards">
        {testTypes.map((t) => (
          <div
            key={t.name}
            className={`test-card${testType === t.name ? ' selected' : ''}`}
            onClick={() => handleTestTypeClick(t.name)}
          >
            <h3>{t.name}</h3>
            <p>{t.description}</p>
          </div>
        ))}
      </div>

      {testStarted && selectedSurah && (
        <div>
          <div className="ayah-buttons">
            {shuffled.map((ay) => (
              <button key={ay.number} onClick={() => selectAyah(ay)}>
                {ay.text}
              </button>
            ))}
          </div>
          <div className="selected-sequence">
            {sequence.map((ay) => (
              <span key={ay.number} className="selected-ayah">
                {ay.text}
              </span>
            ))}
          </div>
          {shuffled.length === 0 && sequence.length > 0 && (
            <button className="check-button" onClick={checkOrder}>
              تحقق
            </button>
          )}
          {result === 'correct' && (
            <p className="correct">أحسنت! الترتيب صحيح</p>
          )}
          {result === 'wrong' && <p className="wrong">الترتيب غير صحيح</p>}
        </div>
      )}

      {showPopup && (
        <div className="overlay">
          <div className="popup-container">
            <div className="popup">
              <div className="popup-header">
              <h3>{testType}</h3>
              <button className="close-button" onClick={() => setShowPopup(false)}>
                  X
                </button>
              </div>
              <div className="popup-content">
                <div className="choose-surah-container">
                  <h3>اختر السورة</h3>
                  <Select
                    className="surah-select"
                    options={surahList}
                    value={selectedSurah}
                    onChange={setSelectedSurah}
                    isSearchable={true}
                    placeholder="ابحث عن سورة..."
                  />
                  <h3>او اختر من المحفوظ</h3>
                  {reviewRanges.length > 0 && (
                    <Select
                      className="surah-select"
                      options={reviewRanges}
                      value={selectedRange}
                      onChange={(opt) => {
                        setSelectedRange(opt);
                        const { surah, start, end } = opt.value;
                        const sOpt = surahList.find((s) => s.value === surah);
                        if (sOpt) setSelectedSurah(sOpt);
                        setMode('range');
                        setStartAyah(String(start));
                        setEndAyah(String(end));
                      }}
                      isSearchable={true}
                      placeholder="اختر من المحفوظ"
                    />
                  )}
                </div>
                <div className="choose-amount-container">
                  <h3>النمط:</h3>
                  <div className="daily-memorize-section">
                    <div className="daily-options">
                      <label>
                        <input
                          type="radio"
                          name="mode"
                          value="full"
                          checked={mode === 'full'}
                          onChange={() => setMode('full')}
                        />
                        <span>السورة كاملة</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="mode"
                          value="range"
                          checked={mode === 'range'}
                          onChange={() => setMode('range')}
                        />
                        <span>تحديد</span>
                      </label>
                    </div>
                    {mode === 'range' && (
                      <div className="range-inputs">
                        <input
                          type="number"
                          placeholder="بداية الآية"
                          value={startAyah}
                          onChange={(e) => setStartAyah(e.target.value)}
                        />
                        <input
                          type="number"
                          placeholder="نهاية الآية"
                          value={endAyah}
                          onChange={(e) => setEndAyah(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="send-button-container">
                    <button
                        className="send-button"
                        onClick={
                            testType === 'ترتيب الايات'
                                ? startOrderingTest
                                : testType === 'اكمل من قولة تعالى'
                                ? startCompleteTest
                                : testType === 'الربط'
                                    ? startLinkingTest
                                    :  () => setTestStarted(true)
                        }
                    >
                    ابدأ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <BottomBar />
    </div>
  );
};

export default ReviewTest;